// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"22e49c6a","455":"9d226a1c","977":"fca0d102"}[chunkId] + ".chunk.js";
};